import { useSelector } from 'react-redux'
import { Navigate } from 'react-router'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import CommunicationBoardForm from '@/containers/DevToolsNew/CommunicationBoard/CommunicationBoardForm'
import SectionCard from '@/containers/DevToolsNew/shared/SectionCard'
import {
  HOME_BOARD_SECTIONS,
  SALES_SCRIPT_SECTIONS,
} from '@/containers/SubscriptionFormPageNew/Components/CommunicationBoard/constants'
import { isSalesScriptAvailable } from '@/containers/SubscriptionFormPageNew/Components/SalesScript/isSalesScriptAvailable'
import { Stack } from '@/containers/DevToolsNew/CommunicationBoard/styled-components'

const SECTIONS = [...Object.values(SALES_SCRIPT_SECTIONS), ...Object.values(HOME_BOARD_SECTIONS)]

const SalesScriptPage = () => {
  const authData = useSelector(selectAuthData)

  if (!isSalesScriptAvailable(authData)) {
    return <Navigate to='/dev-tools-v2/contacts' replace />
  }

  return (
    <Stack>
      <SectionCard>
        <CommunicationBoardForm sections={SECTIONS} />
      </SectionCard>
    </Stack>
  )
}

export default SalesScriptPage
